'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browsers = exports.browsers = require('../../data/browsers');


//////////////////
// WEBPACK FOOTER
// ./~/caniuse-lite/dist/unpacker/browsers.js
// module id = 131
// module chunks = 0